import "../Attractions/attractions.scss";
import image1 from "../assets/image/20211007_120244.jpg";
import { FaHouseDamage, FaTrash, FaRegEdit, FaMapMarkerAlt } from "react-icons/fa";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import Loader from "utilities/Loader";
import { sortArray } from "services/services";

export default function Attractions() {
  const [allItems, setAllItems] = useState([]);
  const [allOptions, setAllOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [updater, setUpdater] = useState(false);
  const [attrac, setAttrac] = useState({
    selectedOption: -1,
    name: "",
    pic: null,
    desc: "",
  });
  const inputRef = useRef();

  const changeHandler = (e) => {
    setAttrac({ ...attrac, [e.target.name]: e.target.value });
    console.log("setAttraction", setAttrac);
  };
  const changeHandlerImg = (e) => {
    setAttrac({ ...attrac, [e.target.name]: e.target.files[0] });
  };

  useEffect(() => {
    let myFormData = new FormData();
    myFormData.append("count", 4);
    myFormData.append("page", 1);
    setIsLoading(true);
    axios
      .post("http://mvc.dade24.ir/api/Find_attractions", {
        data: myFormData,
      })
      .then(function (response) {
        let data = sortArray(response.data, "id")
        setAllItems(data);
      })
      .catch(function (error) {});

    let FD = new FormData();

    axios
      .post("http://mvc.dade24.ir/api/Find_cities", {
        data: FD,
      })
      .then((response) => {
        setAllOptions(response.data);
        setIsLoading(false);
        toast.success("تغییرات موفقیت آمیز!");
      });
  }, [updater]);

  function postTour() {
    let myFormData = new FormData();
    myFormData.append("title", attrac.name);
    myFormData.append("cityid", attrac.selectedOption);
    myFormData.append("description", attrac.desc);
    myFormData.append("mainpic", attrac.pic);
    setIsLoading(true);
    axios.post("http://mvc.dade24.ir/api/Insert_attractions", myFormData).then(() => {
      inputRef.current.value = "";
      setAttrac({ selectedOption: -1, name: "", pic: null, desc: "" });
      setUpdater(!updater);

    })    
  
  }

  function updateTour(attrac2) {

    let myFormData = new FormData();
    myFormData.append("conditions", `id/=/${attrac2.id}`);
    myFormData.append("keyvalues", `title,${attrac2.name2}@@description,${attrac2.desc2}@@mainpic,@@cityid,${attrac2.selectedOption}`);
    console.log("attrac2.pic2", attrac2.pic2);
    myFormData.append("mainpic", attrac2.pic2);

    setIsLoading(true);

    axios.post("http://mvc.dade24.ir/api/Update_attractions", myFormData).then(()=>{setUpdater(!updater)})
    
  }

  function deleteHandler(id) {
    let myFormData = new FormData();
    myFormData.append("conditions", `id/=/${id}`);
    axios.post(`http://mvc.dade24.ir/api/Delete_attractions`, myFormData);
    setUpdater(!updater);
    
  }

  return (
    <div className="bg-white m-4 rounded-3 Attractions" style={{ border: "2px solid gray" }}>
      {/* <!--Under-Head--> */}
      {isLoading && <Loader></Loader>}
      <div className="m-3">
        <button type="button" data-bs-toggle="modal" data-bs-target={`#add-modal`} className="btn" style={{ border: "1px solid #8c8b8b", borderRadius: "10px" }}>
          <span className="mt-2" style={{ fontWeight: "bold", fontSize: "20px", marginTop: "15px", marginLeft: "5px" }}>
            +
          </span>
          <span style={{ color: "#757373" }}>افزودن جاذبه </span>
        </button>
      </div>
      {/* <!--Title-Main--> */}
      <div className="title_main">
        <div className="title_main_text">
          <h4 style={{ fontFamily: "regular", fontWeight: "bold" }}>جاذبه های گردشگری</h4>
        </div>
        <div className="title_main_undertext">
          <FaHouseDamage className="house" />
        </div>
      </div>
      {/* {!isLoading && <Loader></Loader>} */}
      <div className="main_div" dir="ltr">
        {allItems?.map((value, index) => (
          <Attraction key={index} information={value} updateTour={updateTour} deleteHandler={deleteHandler} allOptions={allOptions} />
        ))}
      </div>
      <div className="modal fade" id={`add-modal`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 dir="rtl" className="modal-title" id="exampleModalLabel3">
                افزودن جاذبه گردشگری
              </h5>
              <button type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form action="#">
                <div className="dropdown_edit  m-2  w-100">
                  <label className="modal_label" for="gardeshgary_type_edit">
                    شهر
                  </label>
                  <select onChange={changeHandler} value={attrac.selectedOption} className="form-select" name="selectedOption" id="gardeshgary_type_edit">
                  <option
                selected
                hidden
                disabled
                value="-1"
              >
                انتخاب کنید
              </option>
                    {allOptions?.map((value, index) => (
                      <option key={index} value={value.id}>
                        {value.title}
                      </option>
                    ))}
                    {/* selected={value.id == information.cityid ? true:false} */}
                  </select>
                </div>

                <div className="inputname_edit positionedit m-2  w-100">
                  <label className="modal_label" for="inputname_edit_elder">
                    نام جاذبه
                  </label>
                  <input onChange={changeHandler} name="name" className="form-control w-100" value={attrac.name} type="text" id="inputname_edit_elder" />
                </div>

                <div className="inputimage_edit positionedit   w-100 m-2">
                  <label className="modal_label" for="img_edit">
                    عکس جاذبه
                  </label>
                  <div>
                    <input onChange={changeHandlerImg} ref={inputRef} name="pic" className="form-control" type="file" id="img_edit" accept="image/*" />
                  </div>
                </div>

                <div className="inputtextarea_edit positionedit  w-100  m-2">
                  <label className="modal_label" for="textarea_inputjazebe_edit">
                    توضیحات
                  </label>
                  <textarea onChange={changeHandler} value={attrac.desc} name="desc" className="form-control" id="textarea_inputjazebe_edit" cols="30" rows="4" style={{ resize: "none" }}></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                بستن
              </button>
              <button type="button" className="btn btn-primary btn-sm" data-bs-dismiss="modal" onClick={() => postTour()}>
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Attraction = ({ information, updateTour, deleteHandler, allOptions }) => {
  const [attrac2, setAttrac2] = useState({
    selectedOption: information.cityid,
    name2: information.title,
    pic2: information.mainpic,
    desc2: information.description,
    id: information.id,
  });

  const changeHandler2 = (e) => {
    setAttrac2({ ...attrac2, [e.target.name]: e.target.value });
    console.log("setAttraction2", attrac2);
  };
  const changeHandlerImg2 = (e) => {
    console.log("changeHandlerImg2", e.target.files[0]);
    setAttrac2({ ...attrac2, [e.target.name]: e.target.files[0] });
  };
  return (
    <div className="panel1">
      <div className="m-3"></div>
      <div className="item_panel1 card" style={{ borderRadius: "12px" }}>
        <a className="item_panel_head1 card-header" href="#" style={{ background: "#303481", borderRadius: "8px" }}>
          <a style={{ color: "white" }}>{information.title}</a>
        </a>
        <div className="item_panel_body1 card-body">
          <a href="#">
            <img className="img-responsive" src={information.mainpic == "" ? image1 : "http://mvc.dade24.ir/" + information.mainpic} alt="mabad_hendoa" />
          
          </a>
          <div className="tozihat d-flex" dir="rtl" style={{ textAlign: "right", fontSize: "12px", marginTop: "10px" }}>
            <span className="">
              <FaMapMarkerAlt />
            </span>
            <p className="font-regular ms-2">
              <strong>مکان:</strong>
              {allOptions.map((value) => {
                return value.id == information.cityid ? value.title : null;
              })}
              <br />
              <div>
              <strong>شاخصه:</strong>
              
              <div
                style={{
                  width: "100%",
                  height: "60px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "3",
                  WebkitBoxOrient: "vertical",
                }}
              >
                <p  style={{ fontSize: "13px" }}>
                {information.description}
                </p>
              </div>
              </div>
              
              
            </p>
          </div>

          <button type="button" className="btnclose1" style={{ position: "absolute", left: "5px" }} data-bs-toggle="modal" data-bs-target={`#exampleModal2-${information.id}`}>
            <FaTrash />
          </button>
          <button type="button" className="btnedit1" style={{ position: "absolute", left: "25px" }} data-bs-toggle="modal" data-bs-target={`#edit-modal-${information.id}`}>
            <FaRegEdit />
          </button>
        </div>
        <a className="item_panel_footer1 card-footer" href="#" style={{ background: "#303481", color: "white", textAlign: "center", borderRadius: "8px" }}>
          نوع جاذبه:
          <a style={{ color: "white" }}>دیدنی های ایران</a>
        </a>
      </div>

      <div className="modal fade" id={`edit-modal-${information.id}`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div dir="rtl" className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel3">
                ویرایش جاذبه گردشگری
              </h5>
              <button type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form action="#">
                <div className="dropdown_edit  m-2  w-100">
                  <label className="modal_label" for="gardeshgary_type_edit">
                    شهر
                  </label>
                  <select onChange={changeHandler2} className="form-select" name="selectedOption" id="gardeshgary_type_edit">
                    {allOptions?.map((value, index) => (
                      <option key={index} value={value.id} selected={value.id == information.cityid ? true : false}>
                        {value.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="inputname_edit positionedit m-2  w-100">
                  <label className="modal_label" for="inputname_edit_elder">
                    نام جاذبه
                  </label>
                  <input onChange={changeHandler2} name="name2" className="form-control w-100" type="text" id="inputname_edit_elder" defaultValue={information.title} />
                </div>

                <div className="inputimage_edit positionedit   w-100 m-2">
                  <label className="modal_label" for="img_edit">
                    عکس جاذبه
                  </label>
                  <div>
                    <input onChange={changeHandlerImg2} name="pic2" className="form-control" type="file" id="img_edit" accept="image/*" />
                  </div>
                </div>

                <div className="inputtextarea_edit positionedit  w-100  m-2">
                  <label className="modal_label" for="textarea_inputjazebe_edit">
                    توضیحات
                  </label>
                  <textarea onChange={changeHandler2} name="desc2" className="form-control" id="textarea_inputjazebe_edit" cols="30" rows="4" style={{ resize: "none" }} defaultValue={information.description}></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                data-bs-dismiss="modal"
                onClick={() => {
                  updateTour(attrac2);
                }}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <!--Modal Trash--> */}
      <div className="modal fade" id={`exampleModal2-${information.id}`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header" style={{justifyContent : "end"}}>
              <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
                حذف جاذبه گردشگری
              </h5>
              <button type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
           
            <div className="modal-body modlatrashposition">
              <p>آیا جاذبه مد نظر حذف شود؟</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                خیر
              </button>
              <button
                type="button"
                onClick={() => {
                  deleteHandler(information.id);
                }}
                className="btn btn-danger btn-sm"
                data-bs-dismiss="modal"
              >
                بله
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <!--Modal Edit--> */}
    </div>
  );
};
// http://mvc.dade24.ir/api/Find_cities
